import { render, staticRenderFns } from "./theme-picker.vue?vue&type=template&id=6c598e7a&"
import script from "./theme-picker.vue?vue&type=script&lang=js&"
export * from "./theme-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports